<template>
  <div>
    <div class="row mt-3">
      <!-- <div class="col-lg-4">
        <h4 class="pt-1">Service Request</h4>
        <hr>
        <div v-if="!selectedDate">
          <p>Please select a date.</p>
        </div>
        <div v-if="selectedDate">
          <p>{{ selectedDate.toDateString() }}</p>
          <label style="margin-bottom: 0; margin-top: 10px;">Start Time</label>
          <div class="input-group">
            <select class="form-control" v-model="startHour">
              <option v-for="(hour, index) in hourOptions" :key="'StartHour'+index">{{ hour }}</option>
            </select>
            <select class="form-control" v-model="startMinute">
              <option v-for="(minute, index) in minuteOptions" :key="'StartMinute'+index">{{ minute }}</option>
            </select>
            <select class="form-control" v-model="startAMPM">
              <option v-for="(ampm, index) in ampmOptions" :key="'StartAMPM'+index">{{ ampm }}</option>
            </select>
          </div>
          <label style="margin-bottom: 0; margin-top: 10px;">End Time</label>
          <div class="input-group">
            <select class="form-control" v-model="endHour">
              <option v-for="(hour, index) in hourOptions" :key="'EndHour'+index">{{ hour }}</option>
            </select>
            <select class="form-control" v-model="endMinute">
              <option v-for="(minute, index) in minuteOptions" :key="'EndMinute'+index">{{ minute }}</option>
            </select>
            <select class="form-control" v-model="endAMPM">
              <option v-for="(ampm, index) in ampmOptions" :key="'EndAMPM'+index">{{ ampm }}</option>
            </select>
          </div>
          <hr>
          <button class="mylisting-button dark-button" @click="postJob()">Create Request</button>
        </div>
      </div> -->
      <div class="col-lg-12 calendar" style="min-height: 600px;">
        <calendar-view
          :show-date="showDate"
          class="theme-default holiday-us-traditional holiday-us-official"
          @click-date="onClickDate"
          :date-classes="selectedDateObj"
          :events="calendarJobs"
          @click-event="onClickEvent"
        >
          <calendar-view-header
            slot="header"
            slot-scope="t"
            :header-props="t.headerProps"
            @input="setShowDate"
          />
        </calendar-view>
      </div>
    </div>

    <table class="web-only table table-striped mt-3 mb-5">
      <thead class style="background-color: var(--nannycogreen); color: #fff;">
        <tr class>
          <th scope="col">Date</th>
          <th scope="col">Family</th>
          <th scope="col">Nanny</th>
          <th scope="col">Start Time</th>
          <th scope="col">End Time</th>
          <th scope="col">Status</th>
          <th scope="col">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="job in jobs" :key="job.id" style="cursor: pointer">
          <td>{{ new Date(addCurrentTimeToDate(job.date)).toDateString() }}</td>
          <td>{{ job.poster_name }}</td>
          <td>{{ job.filler_name }}</td>
          <td>
            <span v-if="job.status == 'Approved'">{{ djangotimeformatAMPM(job.start_time) }}</span>
            <span v-else>{{ djangotimeformatAMPM(job.actual_start_time) }}</span>
            <!-- <span v-if="job.status == 'In Progress'">{{ djangotimeformatAMPM(job.actual_start_time) }}</span> -->
          </td>
          <td>
            <span v-if="job.status == 'Approved'">{{ djangotimeformatAMPM(job.end_time) }}</span>
            <span v-else>{{ djangotimeformatAMPM(job.actual_end_time) }}</span>
          </td>
          <td>{{ job.status }}</td>
          <td>
            <router-link
              :to="{ name: 'Job', params: { id: job.id } }"
              class="mylisting-button dark-button"
              target="_blank"
            >View Job Listing</router-link>
            <!-- <button v-if="job.status == 'Approved'" class="mylisting-button dark-button" @click="showClockInModal(job)">Clock In</button> -->
            <!-- <button v-if="job.status == 'In Progress'" class="mylisting-button dark-button" @click="showClockOutModal(job)">Clock Out</button> -->
          </td>
        </tr>
      </tbody>
    </table>

    <modal name="job-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <!-- <h2>Status updated.</h2> -->
        <!-- {{ job }} -->
        <h4>{{ job.poster_name }} - {{ new Date(job.date).toDateString() }}</h4>
        <hr>
        <p>Start Time: {{ djangotimeformatAMPM(job.start_time) }}</p>
        <p>End Time: {{ djangotimeformatAMPM(job.end_time) }}</p>
        <pre v-if="job.text2">Preferred Nanny: {{ job.text2 }}</pre>
        <pre v-if="job.text">Special Notes: {{ job.text }}</pre>
        <hr>

        <!-- <h5>Filled By: {{ job.filler_name }}</h5>
        <p class="mb-1">Current Status: {{ job.status }}</p>
        <div class="input-group" style="max-width: 450px;">
          <select class="form-control" v-model="status">
            <option v-for="(statusOption, index) in statuses" :key="index">{{ statusOption }}</option>
          </select>
          <button class="btn btn-secondary" @click="updateStatus()">Update Status</button>
        </div> -->
        <div class="row">
          <div class="col-lg-6 mb-3">
            <h5 v-if="job.filler_name">Filled By: {{ job.filler_name }}</h5>
            <p class="mb-1">Current Status: {{ job.status }}</p>
            <div class="input-group" style="">
              <select class="form-control" v-model="status">
                <option v-for="(statusOption, index) in statuses" :key="index">{{ statusOption }}</option>
              </select>
              <button class="btn btn-secondary" @click="updateStatus()">Update Status</button>
            </div>
            <p class="mt-3">Assign a Nanny</p>
            <div class="input-group mt-1" style="">
              <select class="form-control" v-model="candidateSelection">
                <option v-for="(candidateEmail, index) in candidateEmails" :key="index">{{ candidateEmail }}</option>
              </select>
              <button class="btn btn-secondary" @click="assign()" v-if="candidateSelection">Assign</button>
            </div>
          </div>
          <div class="col-lg-6">
            <app-map v-if="job.city" :locationObject="job" :latlng1="job.multiselect2" :latlng2="job.multiselect3" accessLevel="full"></app-map>
          </div>
        </div>

        <div v-if="applications.length">
          <hr>
          <button class="btn btn-secondary" @click="refreshApplications()">Refresh</button>
          <!-- <p>{{ applications }}</p> -->
          <table class="table table-striped mt-2 shadow">
            <thead class="" style="background-color: var(--coredarkcolor); color: var(--corelightcolor);">
              <tr class="">
                <th scope="col">Name</th>
                <th scope="col">Broadcast Date</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="application in applications" :key="application.id" style="cursor: pointer;">
                <td>
                  {{ application.applicant_name }}
                </td>
                <td>
                  <p>{{ new Date(application.date).toDateString() }}</p>
                </td>
                <td>
                  {{ application.status }}
                  <!-- <button class="btn btn-danger" @click="deleteApplication(application)">Delete</button> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('job-modal')" style="">Close</button>
        <!-- <div style="margin-top: 20px; margin-bottom: 20px;"> -->
          <router-link
            :to="{ name: 'Job', params: { id: job.id } }"
            class="mylisting-button dark-button"
            target="_blank"
          >View Job Listing</router-link>
        <!-- </div> -->
        <!-- <button class="mylisting-button danger-button" @click="$modal.show('delete-job-modal')" style="float: right;">Delete</button> -->
        <button v-if="!applications.length" class="mylisting-button dark-button" @click="showBroadcastModal()" style="float: right;">Broadcast</button>
        <p @click="$modal.show('delete-job-modal')" style="color: red; cursor: pointer;" class="mt-3">Delete Request</p>

      </div>
    </modal>

    <modal name="status-updated-modal" width="75%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Status updated.</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('status-updated-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="delete-job-modal" width="75%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h3>Are you sure you want to delete this request?</h3>
        <!-- <p>{{ user.first_name }} {{ user.last_name }}</p> -->
        <!-- <p>{{ user.email }}</p> -->
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('delete-job-modal')" style="">Cancel</button>
        <button class="mylisting-button danger-button" @click="deleteJob()" style="float: right;">Delete</button>
      </div>
    </modal>

    <modal name="broadcast-modal" width="75%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Please select which nannies you would like to broadcast this to</h2>
        <hr>
        <div v-for="(candidate, index) in candidates" :key="'Candidate'+index">
          <h5 @click="selectCandidate(candidate)" style="cursor: pointer;">{{ candidateEmails[index] }} <span v-if="selectedCandidates.includes(candidate)"><i style="font-size: 15px;" class="material-icons mt-1">check_circle</i></span></h5>
        </div>
        <!-- {{ selectedCandidates }} -->
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('broadcast-modal')" style="">Close</button>
        <button class="mylisting-button dark-button" @click="broadcast()" style="float: right;">Broadcast</button>
      </div>
    </modal>

    <modal name="successfully-broadcasted-modal" width="75%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Broadcast sent!</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('successfully-broadcasted-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="nanny-assigned-modal" width="75%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Nanny assigned!</h2>
        <h5>The client has been notified.</h5>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('nanny-assigned-modal')" style="">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar";
require("vue-simple-calendar/static/css/default.css");

import Map from '../global/Map.vue';

export default {
  // props: ['user'],
  components: {
    CalendarView,
    CalendarViewHeader,
    appMap: Map,
  },
  data () {
    return {
      showDate: new Date(),
      selectedDateObj: {},

      selectedDate: null,
      selectedFilterEmployer: "", //v-model to employer Email

      // startHour: 'HH',
      // startMinute: 'MM',
      // startHour: '01',
      startHour: 1,
      startMinute: '00',
      startAMPM: 'AM',
      startTime: null,
      // endHour: '01',
      endHour: 1,
      endMinute: '00',
      endTime: null,
      endAMPM: 'AM',

      // hourOptions: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
      // hourOptions: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      // hourOptions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      hourOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      minuteOptions: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'],
      ampmOptions: ['AM', 'PM'],

      // events: [{id: 0, startDate: '2020-04-5 09:00:00', title: 'Goel Family'}, {id: 1, startDate: '2020-04-12 09:00:00', title: 'Goel Family'}, {id: 2, startDate: '2020-04-19 09:00:00', title: 'Goel Family'}],

      jobs: [],
      calendarJobs: [],
      job: {},
      jobPoster: {},

      applications: [],

      status: '',
      statuses: [],

      candidates: [],
      candidateEmails: [],
      selectedCandidates: [],

      filterFamilyOptions: [],
      filterNannyOptions:[],
      filterNanny: [],
      filterFamily: [],
      filterStatus: [],
      filterStart: '',
      filterEnd: '',

      candidateSelection: '',

      tab: 'month',
    }
  },
  created() {
    // this.getJobs() // Going to get the jobs initially in the getCandidates method so that the candidates load first, so we can sort jobs by candidate
    this.getCandidates()
    this.statuses = this.$store.getters.jobStatuses
  },
  methods: {
    setShowDate(d) {
      this.showDate = d;
    },
    onClickDate(d) {
      console.log('date clicked')
      console.log(d)
      this.selectedDate = d

      // this.currentStep = 1;
      // this.selectedStartDate = d;
      // // this.selectedStartDate = d.toISOString().substring(0, 10);
      // this.selectedDateObj = {
      //   [this.selectedStartDate]: "ClassForSelectedDate"
      // };
      // console.log("selected date", this.selectedDateObj);
    },
    onClickEvent(event) {
      console.log(event)
      axios.get(`/api/jobs/?id=${event.id}`)
        .then(res => {
          console.log(res)
          this.job = res.data[0]
          this.status = this.job.status

          this.getApplications(this.job)
          // axios.get(`/api/jobapplications/?job=${this.job.id}`)
          //   .then(res => {
          //     console.log(res)
          //     this.applications = res.data

          //     this.$modal.show('job-modal')
          //   })
          //   .catch(error => console.log(error))
          this.getJobPoster()
          this.$modal.show('job-modal')
        })
        .catch(error => console.log(error))
    },
    getJob(jobID) {
      axios.get(`/api/jobs/?id=${jobID}`)
        .then(res => {
          console.log(res)
          this.job = res.data[0]
          this.status = this.job.status
        })
        .catch(error => console.log(error))
    },
    getJobPoster() {
      axios.get(`/api/people/?id=${this.job.poster}`)
        .then(res => {
          this.jobPoster = res.data[0]
        })
        .catch(error => console.log(error))
    },
    getJobs() {
      axios.get(`/api/jobs/?agency=${this.$store.getters.agencyID}&job_type=Short Term`)
        .then(res => {
          console.log(res)
          this.jobs = res.data
          this.jobs = this.jobs.sort((a, b) => (a.date < b.date) ? 1 : -1)

          this.calendarJobs = []

          for (var job in this.jobs) {
            // this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'title': `${this.jobs[job].start_time} - ${this.jobs[job].end_time}`})
            // this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status})`})
            if (!(this.filterFamilyOptions.includes(this.jobs[job].poster_name))){
              this.filterFamilyOptions.push(this.jobs[job].poster_name)
            }
            this.filterFamilyOptions= this.filterFamilyOptions.sort()

            // If the job is filled, get the candidate who is filling the job
            let candidate = null
            if (this.jobs[job].filler) {
              candidate = this.candidates.filter(element => {
                return element.id == this.jobs[job].filler;
              })[0];
            }

            if (this.jobs[job].status == 'Requested') {
              this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal; border-color: #ff6969; background-color: #ff6969;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status})`})
            }
            else if (this.jobs[job].status == 'Pending') {
              this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal; border-color: #FFB6C1; background-color: #FFB6C1;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status})`})
            }
            else if (this.jobs[job].status == 'Assigned') {
              this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal; ', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status} - ${this.jobs[job].filler_name})`})
              // let candidate = this.candidates.filter(element => {
              //   return element.id == this.jobs[job].filler;
              // })[0];
              // console.log(candidate)
              // console.log(this.candidates.indexOf(candidate))
              // console.log(this.candidates[this.candidates.indexOf(candidate)])

              if (candidate) {
                this.candidates[this.candidates.indexOf(candidate)].jobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal; ', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status})`})
              }
            }
            else if (this.jobs[job].status == 'In Progress') {
              this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal; border-color: #6dc96d; background-color: #6dc96d;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status} - ${this.jobs[job].filler_name})`})
              // let candidate = this.candidates.filter(element => {
              //   return element.id == this.jobs[job].filler;
              // })[0];

              if (candidate) {
                this.candidates[this.candidates.indexOf(candidate)].jobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal; border-color: #6dc96d; background-color: #6dc96d;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status})`})
              }
            }
            else if (this.jobs[job].status == 'Completed') {
              this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal; border-color: #f5f5dc; background-color: #f5f5dc;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status} - ${this.jobs[job].filler_name})`})

              if (candidate) {
                this.candidates[this.candidates.indexOf(candidate)].jobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal; border-color: #f5f5dc; background-color: #f5f5dc;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status})`})
              }
            }
            else if (this.jobs[job].status == 'Approved') {
              this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal; border-color: #f5f5dc; background-color: #f5f5dc;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status} - ${this.jobs[job].filler_name})`})

              if (candidate) {
                this.candidates[this.candidates.indexOf(candidate)].jobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal; border-color: #f5f5dc; background-color: #f5f5dc;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status})`})
              }
            }
          }

        })
        .catch(error => {
          console.log(error)
        })
    },
    getApplications(job) {
      axios.get(`/api/jobapplications/?job=${job.id}`)
        .then(res => {
          console.log(res)
          this.applications = res.data

          // this.$modal.show('job-modal')
        })
        .catch(error => console.log(error))
    },
    refreshApplications() {
      this.getApplications(this.job)
    },
    postJob() {
      console.log('Posting job')

      if (this.startHour == 12) {
        this.startHour -= 12
      }
      // else {
      //   this.startHour -= 1
      // }
      if (this.startAMPM == 'PM') {
        this.startHour += 12
      }
      this.startHour = ("0" + this.startHour).slice(-2);

      if (this.endHour == 12) {
        this.endHour -= 12
      }
      // else {
      //   this.endHour -= 1
      // }
      if (this.endAMPM == 'PM') {
        this.endHour += 12
      }
      this.endHour = ("0" + this.endHour).slice(-2);

      // this.events.push({id: 4, startDate: this.selectedDate, title: 'Enginehire Family'})
      axios.post('/api/jobs/', {
        poster: this.user.id,
        poster_name: this.user.employer_name,
        date: this.dateInDjangoFormat(this.selectedDate),
        // start_time: this.convertTimeFormat(`${this.startHour}:${this.startMinute}${this.startAMPM}`),
        // end_time: this.convertTimeFormat(`${this.endHour}:${this.endMinute}${this.endAMPM}`),
        start_time: `${this.startHour}:${this.startMinute}:00`,
        end_time: `${this.endHour}:${this.endMinute}:00`,
        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID,
      })
        .then(res => {
          console.log(res)
          this.getJobs()
        })
        .catch(error => {
          console.log(error)
        })
    },
    deleteJob() {
      axios.delete(`/api/jobs/${this.job.id}`)
        .then(res => {
          console.log(res)
          this.getJobs()
          this.$modal.hide('job-modal')
          this.$modal.hide('delete-job-modal')
        })
        .catch(error => {
          console.log(error)
        })
    },
    deleteApplication(application) {
      axios.delete(`/api/jobapplications/${application.id}`)
        .then(res => {
          console.log(res)
          this.getApplications(this.job)
        })
        .catch(error => {
          console.log(error)
        })
    },
    updateStatus() {
      axios.patch(`/api/jobs/${this.job.id}/`, {
        status: this.status
      })
        .then(res => {
          console.log(res)
          this.job.status = this.status
          this.getJobs()
          this.$modal.show('status-updated-modal')
        })
        .catch(error => {
          console.log(error)
        })
    },
    showBroadcastModal() {
      // this.getCandidates()
      this.$modal.show('broadcast-modal')
    },
    getCandidates() {
      axios.get(`/api/people/?agency=${this.$store.getters.agencyID}&is_candidate=true&status=${this.$store.getters.candidateActiveStatus}`)
        .then(res => {
          this.candidates = res.data;

          for (var candidate in this.candidates) {
            this.candidates[candidate].jobs = []
            this.candidates[candidate].calendarJobs = []
            this.candidates[candidate].currentWeekAvailability = {'monday': [], 'tuesday': [], 'wednesday': [], 'thursday': [], 'friday': [], 'saturday': [], 'sunday': [], }
          }

          console.log("Candidates", this.candidates);
          this.candidateEmails = this.candidates.map(
            candidate => `${candidate.first_name} ${candidate.last_name} [${candidate.email}]`
          );

          this.getJobs()
        })
        .catch(error => console.log(error));
    },
    selectCandidate(candidate) {
      //
      // What happens when clicking on a candidate in the list of candidates
      //
      if (!this.selectedCandidates.includes(candidate)) { // If we haven't already selected a time, select it
        this.selectedCandidates.push(candidate)
      }
      else {
        this.selectedCandidates.splice(this.selectedCandidates.indexOf(candidate), 1)
      }
    },
    broadcast() {
      // Send out the notification
      for (var candidate in this.selectedCandidates) {
        console.log(this.selectedCandidates[candidate])
        axios.post(`/api/jobapplications/`, {
          applicant: this.selectedCandidates[candidate].id,
          applicant_name: `${this.selectedCandidates[candidate].first_name} ${this.selectedCandidates[candidate].last_name}`,
          job: this.job.id,
          job_title: this.job.poster_name,
          status: 'No Response',
          agency_owner: this.$store.getters.agencyName,
          agency: this.$store.getters.agencyID,
        })
          .then(res => {
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter
            let selectedCandidate = this.selectedCandidates.filter(user => user.id == res.data.applicant)[0]
            console.log(selectedCandidate)

            // if (this.selectedCandidates[candidate].preferences3.includes('Email')) { // If the candidate wants to be notified via email
            if (selectedCandidate.preferences3.includes('Email')) { // If the candidate wants to be notified via email
              this.$store.dispatch('sendEmail',
                {
                  subject: `New Opportunity ${new Date(this.addCurrentTimeToDate(this.job.date)).toDateString()}, ${this.djangotimeformatAMPM(this.job.start_time)} - ${this.djangotimeformatAMPM(this.job.end_time)}`,
                  // message: 'Hello ' + this.selectedCandidates[candidate].first_name + ',\n\n' +
                  message: 'Hello ' + selectedCandidate.first_name + ',\n\n' +
                  'A family has posted a request for a nanny that you might be interested in!\n' +
                  // `To see all the details please go to localhost:8080/job/${this.job.id} \n\n` +
                  `To see all the details please go to https://pinknannies.enginehire.io/job/${this.job.id} \n\n` +
                  `Date: ${new Date(this.addCurrentTimeToDate(this.job.date)).toDateString()}\n` +
                  `Start Time: ${this.djangotimeformatAMPM(this.job.start_time)}\n` +
                  `End Time: ${this.djangotimeformatAMPM(this.job.end_time)}\n\n` +
                  'Even if you are not interested we would really appreciate it if you could go to the link to let us know!\n\n' +
                  'Thanks!\n'+
                  'The Nanny Company Team',
                  from: this.$store.getters.agencyFromEmail,
                  // email: this.selectedCandidates[candidate].email,
                  email: selectedCandidate.email,
                  reply: this.$store.getters.agencyReplyEmail,
                  // userID: this.aakashid,
                  // userID: this.selectedCandidates[candidate].id,
                  userID: selectedCandidate.id,
                }
              )
            }

            // Increment the counter for the number of broadcasts this candidate has received
            // let statsArray = this.selectedCandidates[candidate].numberArray
            let statsArray = selectedCandidate.numberArray
            // console.log(statsArray)
            statsArray[0] += 1
            // console.log(statsArray)
            // axios.patch(`/api/people/${this.selectedCandidates[candidate].id}/`, {
            axios.patch(`/api/people/${selectedCandidate.id}/`, {
              numberArray: statsArray
            })
              .catch(error => console.log(error))

            if (candidate == (this.selectedCandidates.length - 1)) { // If we just processed the last candidate in the list
              this.getApplications(this.job)
              this.$modal.show('successfully-broadcasted-modal')
              this.$modal.hide('broadcast-modal')

              axios.patch(`/api/jobs/${this.job.id}/`, {
                status: 'Pending',
              })
                .then(res => {
                  console.log(res)
                  this.job.status = 'Pending'
                  this.status = 'Pending'
                })
                .catch(error => console.log(error))
            }
          })
          .catch(error => console.log(error))
      }
      // this.$modal.show('successfully-broadcasted-modal')
      // this.$modal.hide('broadcast-modal')
    },
    // --------------- Group of functions for manually assigning a nanny to a job ----------------
    showCandidateAssignmentModal() {
      this.candidateSelection = ''
      // this.candidateEmployerRelationshipStatus = ''
      this.$modal.show('candidate-assignment-modal')
    },
    getCandidateObject(emailName) {
      //this helper method will allow me to link an invoice to a candidate object
      return this.candidates.filter(element => {
        //since the invoice object does not contain an email, I will have to link the payee_id to the appropriate candidate
        return element.email == this.extractEmail(emailName);
      });
    },
    extractEmail(emailName) {
      let emailRegExp = /\[([^)]+)\]/; //this will extract the email within parentheses
      return emailRegExp.exec(emailName)[1];
    },
    assign() {
      //
      // Manually assign a nanny to a job
      //
      let selectedCandidateObj = this.getCandidateObject(this.candidateSelection)[0];
      console.log(selectedCandidateObj)

      axios.patch(`/api/jobs/${this.job.id}/`, {
        status: 'Assigned',
        filled: true,
        filler: selectedCandidateObj.id,
        filler_name: `${selectedCandidateObj.first_name} ${selectedCandidateObj.last_name}`,
        filled_date: new Date,
      })
        .then(res => {
          console.log(res)
          this.getJob(this.job.id)
          this.getJobs()
          this.candidateSelection = ''
          this.$modal.show('nanny-assigned-modal')

          this.$store.dispatch('sendEmails',
            {
              subject: `Nanny Assigned for ${new Date(this.job.date).toDateString()}`,
              message: `Hello ${this.job.poster_name},` + '\n\n' +
              `Our nanny ${selectedCandidateObj.first_name} ${selectedCandidateObj.last_name} has been assigned to your service request on ${new Date(this.job.date).toDateString()}.\n`+
              `To view more details about the nanny, please log into your dashboard (${this.$store.getters.platformLoginURL}) and click on your service request.\n\n` +
              'Please don\'t hesitate to reach out if you have any questions or issues!\n\n' +
              'Thank you,\n'+
              `${this.$store.getters.agencyHumanName} Team`,
              from: this.$store.getters.agencyFromEmail,
              emails: [this.$store.getters.enginehireLoggingEmail, this.jobPoster.email],
              reply: this.$store.getters.agencyReplyEmail,
              // userID: this.aakashid,
              userID: this.jobPoster.id,
            }
          )

          this.$store.dispatch('sendEmails',
            {
              subject: `Job Assigned for ${new Date((this.job.date)).toDateString()}`,
              message: `Hello ${selectedCandidateObj.first_name},` + '\n\n' +
              `You have been assigned to a job on ${new Date((this.job.date)).toDateString()}.\n`+
              // `Your family contact is ${this.jobPoster.first_name} ${this.jobPoster.last_name} (${this.jobPoster.phone})\n` +
              `To view more details about the job, please log into your dashboard (${this.$store.getters.platformLoginURL}) and click on the "My Jobs" tab.\n\n` +
              'Please don\'t hesitate to reach out if you have any questions or issues!\n\n' +
              'Thank you,\n'+
              `${this.$store.getters.agencyHumanName} Team`,
              from: this.$store.getters.agencyFromEmail,
              emails: [this.$store.getters.enginehireLoggingEmail, selectedCandidateObj.email],
              reply: this.$store.getters.agencyReplyEmail,
              // userID: this.aakashid,
              userID: selectedCandidateObj.id,
            }
          )
        })
        .catch(error => console.log(error))
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/agents/MasterCalendar.vue